<template>
  <main>
    <simple-navigation></simple-navigation>

    <section class="wrapper align-items-center pb-12 f-column min-win-height">
      <div class="container-860">
        <h2 class="font-center">
          Ospravedlňujeme sa,
        </h2>
        <div class="container-full pl-10 pr-10 pl-2-768 pr-2-768 pr pb-4 f-center f-column mb-children-3 font-center">
          <strong class="font-center font-medium">online aplikácia pre obhliadku vozidla je z technických príčin dočasne
            nedostupná.</strong>
          <p class="font-center">
            Prosím, skúste obhliadku vykonať neskôr. Ak potrebujete obhliadku vykonať ihneď, prosím kontaktujte naše
            zákaznícke centrum na tel. čísle
            <a href="tel:0850003333">0850 003 333</a>
            alebo e-mailom na
            <a href="mailto:union@union.sk">union@union.sk</a>.
          </p>
          <p class="font-center">Ďakujeme za pochopenie.</p>
        </div>
      </div>
      <transparent-footer></transparent-footer>
    </section>
  </main>
</template>

<script>
import { mapGetters } from 'vuex';
import SimpleNavigation from '@/components/navigation/SimpleNavigation.vue';
import TransparentFooter from '@/components/footer/TransparentFooter.vue';

export default {
  name: 'Error',
  components: {
    SimpleNavigation, TransparentFooter,
  },
  computed: {
    ...mapGetters({
      model: 'getModel',
    }),
  },
  created() {
    if (this.model.serviceAvailability) {
      this.$router.goToStep(this.model.step);
    }
  },
};
</script>
<style scoped lang="scss">
@import "~union_styles/scss/variables";

a {
  text-decoration: underline;
}

a:hover {
  color: $color-red;
}

</style>
